module.exports = __webpack_public_path__ + "static/media/1.f702d275.jpg";